export const Marquee = ({ words }) => {
  const row = [...words, ...words, ...words];
  return (
    <div className="relative overflow-hidden border-y border-[#E2DDD5] py-8 lg:py-12" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`f-serif px-8 text-5xl lg:text-8xl ${i % 2 ? "italic text-[#005F60]" : "text-[#121518]"}`}>{w}</span>
                <span className="h-3 w-3 rotate-45 bg-[#FF682F]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
